const activeTimeouts = new Set();

export const loadImageFromURL = (imageSrc, onErrorCallback) => {
  return new Promise((resolve, reject) => {
    loadImage(imageSrc, resolve, reject, onErrorCallback);
  });
};

export const clearLoadImageTimeouts = () => {
  activeTimeouts.forEach(timeoutId => clearTimeout(timeoutId));
  activeTimeouts.clear();
};

function loadImage(imageSrc, resolve, reject, onErrorCallback, reqCount = 0) {
  reqCount++;
  const image = new Image();
  image.setAttribute('crossorigin', 'anonymous');
  image.onload = function () {
    const fabricImage = new global.fabric.Image(image);
    fabricImage.crossOrigin = 'anonymous';
    scaleFabricImage(fabricImage);
    resolve(fabricImage);
  };
  image.onerror = function () {
    if (reqCount >= 3) {
      onErrorCallback();
      reject(new Error('Image failed to create!'));
    } else {
      const timeoutId = setTimeout(() => {
        activeTimeouts.delete(timeoutId);
        loadImage(imageSrc, resolve, reject, onErrorCallback, reqCount);
      }, 2000);
      activeTimeouts.add(timeoutId);
    }
  };
  image.src = imageSrc + '?_=' + Date.now();
}

function scaleFabricImage(fabricImage, retry = 1) {
  const container = document.querySelector('div.editing-img');
  
  // If container is not available or has zero dimensions, retry after a delay
  if (!container || container.clientWidth <= 0 || container.clientHeight <= 0) {
    if (retry > 5) {
      console.warn('Container not available after retries, using default scale');
      fabricImage.scale(0.5);
      return fabricImage;
    }
    const timeoutId = setTimeout(() => {
      activeTimeouts.delete(timeoutId);
      const containerCheck = document.querySelector('div.editing-img');
      if (containerCheck) {
        scaleFabricImage(fabricImage, retry + 1);
      }
    }, 50);
    activeTimeouts.add(timeoutId);
    return fabricImage;
  }
  
  const effectiveContainerWidth = container.clientWidth;
  const effectiveContainerHeight = container.clientHeight;
  
  // Prevent infinite recursion - max 20 retries
  if (retry > 20) {
    console.warn('Max scaling retries reached, using fallback scale based on container and image dimensions');
    
    const imageWidth = fabricImage.width || 0;
    const imageHeight = fabricImage.height || 0;
    
    if (effectiveContainerWidth > 0 && effectiveContainerHeight > 0 && imageWidth > 0 && imageHeight > 0) {
      const widthRatio = effectiveContainerWidth / imageWidth;
      const heightRatio = effectiveContainerHeight / imageHeight;
      let maxScale = Math.min(widthRatio, heightRatio, 1);
      if (maxScale <= 0) {
        maxScale = 0.5;
      }
      fabricImage.scale(maxScale);
    } else {
      fabricImage.scale(0.5);
    }
    return fabricImage;
  }
  
  if ((fabricImage.getScaledWidth() > effectiveContainerWidth) || (fabricImage.getScaledHeight() > effectiveContainerHeight)) {
    let widthScaleFactor = fabricImage.getScaledWidth() / effectiveContainerWidth;
    let heightScaleFactor = fabricImage.getScaledHeight() / effectiveContainerHeight;
    let scaleFactor = Math.max(widthScaleFactor, heightScaleFactor);
     (scaleFactor > 1.1) ? fabricImage.scale(fabricImage.scaleX / (scaleFactor * 1.05)) : fabricImage.scale(1 - retry * 0.05);
    return scaleFabricImage(fabricImage, ++retry);
  } else {
    return fabricImage;
  }
}
